<template>
  <div :class="['main_menu', mstyle === 'white' ? 'white_menu' : '', mstyle === 'dark' ? 'dark_menu' : '']">
    <router-link to="/" class="logo">VANIPLATE</router-link>
    <div class="open_menu">
      <img :src="`/img/burger-menu${mstyle === 'white' ? '-black' : ''}.svg`" @click="open_menu = true"/>
    </div>

    <div class="modal_menu" v-if="open_menu">
      <img src="../../assets/img/close.svg" class="absolute_img" @click="open_menu=false" />
      <ul class="modal_menu__links">
        <li v-for="link in links" :key="link.index" class="modal_link_item">
          <router-link :to="link.link">{{ link.name }}</router-link>
        </li>
      </ul>
    </div>

    <ul class="links">
      <li v-for="link in links" :key="link.index">
        <router-link :to="link.link" class="links__item">{{ link.name }}</router-link>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: "MainMenu",

  props: {
    mstyle: String
  },

  data() {
    return {
      open_menu: false
    }
  },

  computed: {
    ...mapState(['links'])
  }
}
</script>

<style lang="sass" scoped>
@import "@/assets/sass/style.sass"
</style>